<template>
  <Section>
    <BarChart style="height: 250px" :chartData="chartData" :options="options" />
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import { BarChart } from 'vue-chart-3';

  function truncate(s, l) {
    return s.length < l ? s : s.substring(0, l-1) + '...'
  }

  export default {
    name: 'DashboardBarChart',

    props: ['data', 'labels', 'title'],
    
    data() {
      return {
        current: -1,
      }
    },

    components: { Section, BarChart },

    computed: {
      chartData() {
        return {
          labels: this.labels.map(l => truncate(l, 16)),
          datasets: [
            {
              data: this.data[0],
              backgroundColor: this.$vuetify.theme.themes.light.secondary,
            },
          ],
        }
      },

      options() {
        return {
          onClick: this.handleClick,

          plugins: {
            legend: { display: false, },
            title: { display: true, text: this.title },
            tooltip: { enabled: false },
          },
          
          responsive: true, 
        
          scales: {
            y: {
              ticks: { precision: 0, },
            }
          },
        }
      },
    },

    methods: {
      handleClick(_point, event) {
        // ignore clicks outside the bars
        if (event.length > 0) {
          const clicked = event[0].index

          if(clicked != this.current) {
            this.current = clicked
            this.$emit('drill', clicked)
          } else {
            this.current = -1
            this.$emit('clear')
          }
        }
      }
    },
  }
</script>